(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/ticker/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/widgets/ticker/assets/javascripts/constants.js');

'use strict';

const TickerBrand = {
  BINGO: 'bingo',
  CASINO: 'casino',
  MOMANG: 'momang'
};
const TickerFeed = {
  BINGO: 'bingo',
  SLOTS: 'slots',
  LIVE_CASINO: 'livecasino'
};
const TickerType = {
  WINNERS: 'winners',
  PROMO: 'promo'
};
const PromoLetters = {
  [TickerBrand.BINGO]: ['B', 'I', 'N', 'G', 'O'],
  [TickerBrand.MOMANG]: ['M', 'O', 'M', 'A', 'N', 'G'],
  [TickerBrand.CASINO]: ['C', 'A', 'S', 'I', 'N', 'O']
};
const toExport = {
  TickerBrand,
  TickerFeed,
  TickerType,
  PromoLetters
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.widget.ticker.constants', toExport);
}

 })(window);